import React, { useState, useEffect } from "react";
import axios from "axios";

/* ---- SHARED UI STYLES ---- */
const labelStyle = { fontSize: "18px", fontWeight: "600", color: "#000", marginBottom: "4px" };
const inputStyle = { fontSize: "14px", border: "1px solid #0C3B6C", padding: "10px", borderRadius: "8px", width: "100%", background: "#fff" };
const buttonStyle = { background: "linear-gradient(180deg, #60A5FA 0%, #2563EB 100%)", color: "#fff", padding: "14px 30px", borderRadius: "8px", fontSize: "18px", fontWeight: "600", border: "none", cursor: "pointer" };
const deleteBtnStyle = { background: "#d9534f", color: "#fff", padding: "8px 18px", borderRadius: "8px", fontSize: "18px", fontWeight: "600" };

// Generate or get current session ID
const getSessionId = () => {
  let sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) {
    sessionId = Date.now().toString() + Math.floor(Math.random() * 1000);
    localStorage.setItem("currentSessionId", sessionId);
  }
  return sessionId;
};

const AddDesignation = () => {
  const sessionId = getSessionId();

  const [designations, setDesignations] = useState([]);
  const [designationName, setDesignationName] = useState("");
  const [designationType, setDesignationType] = useState("Teacher"); // ✅ moved inside component

  // ✅ Fetch designations TYPE wise
  const fetchDesignations = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/getDesignations`,
        {
          params: {
            sessionId,
            type: designationType
          }
        }
      );
      setDesignations(response.data);
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  // 🔁 Re-fetch when type changes
  useEffect(() => {
    fetchDesignations();
  }, [designationType]);

  // ✅ Create designation with type
  const handleAddDesignation = async () => {
    const trimmedName = designationName.trim();
    if (!trimmedName) return;

    const isDuplicate = designations.some(
      d => d.designationName.toLowerCase() === trimmedName.toLowerCase()
    );
    if (isDuplicate) {
      alert("This designation already exists.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/createDesignation`,
        {
          designationName: trimmedName,
          sessionId,
          type: designationType // ✅ important
        }
      );

      setDesignations([...designations, response.data]);
      setDesignationName("");
      alert("Designation added successfully");
    } catch (error) {
      alert(error.response?.data?.message || "Error adding designation");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/deleteDesignation/${id}`
      );
      setDesignations(designations.filter(d => d._id !== id));
      alert("Designation deleted successfully");
    } catch (error) {
      alert("Error deleting designation");
    }
  };

  return (
    <div className="w-full p-3 text-left">

      {/* CREATE DESIGNATION */}
      <div className="bg-white p-4 mb-8 shadow rounded-lg">
        <h2 className="font-semibold mb-4 text-gray-800">
          Create New Designation
        </h2>

        <label style={labelStyle}>Designation Name</label>
        <input
          type="text"
          style={inputStyle}
          value={designationName}
          onChange={(e) => setDesignationName(e.target.value)}
        />

        <label style={labelStyle}>Designation Type</label>
        <select
          style={inputStyle}
          value={designationType}
          onChange={(e) => setDesignationType(e.target.value)}
        >
          <option value="Teacher">Teacher</option>
          <option value="Non-Teacher">Non-Teacher</option>
        </select>

        <button onClick={handleAddDesignation} className="mt-5" style={buttonStyle}>
          Save Designation
        </button>
      </div>

      {/* LIST */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="font-semibold mb-4 text-gray-800">
          {designationType} Designations
        </h2>

        <table className="min-w-full border">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-3 border">Sr. No.</th>
              <th className="p-3 border">Designation ID</th> {/* new */}
              <th className="p-3 border">Designation Name</th>
              <th className="p-3 border">Action</th>
            </tr>
          </thead>

          <tbody>
            {designations.length > 0 ? (
              designations.map((d, i) => (
                <tr key={d._id}>
  <td className="p-3 border">{i + 1}</td>

  {/* ⭐ designation ID */}
  <td className="p-3 border text-blue-600 font-semibold">
    {d._id}
  </td>

  <td className="p-3 border">{d.designationName}</td>

  <td className="p-3 border">

                    <button
                      onClick={() => handleDelete(d._id)}
                      style={deleteBtnStyle}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="p-4 text-center text-gray-500">
                  No designations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddDesignation;
